import React, { FC } from 'react';

import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import styled from '../../../../styled';
import { colorsPalette, SMALL_MARGIN_PX } from '../../../../theme';

interface CardProgressLabelProps {
  current: number;
  total: number;
}

const CardProgressLabel: FC<CardProgressLabelProps> = ({ current, total }) => {
  const { t } = useTranslation();
  return <StyledTypo>{t('page.pathway.progressLabel', { current, total })}</StyledTypo>;
};

export default CardProgressLabel;

const StyledTypo = styled(Typography)`
  position: absolute;
  font-size: 14px;
  font-weight: normal;
  right: 9px;
  bottom: ${SMALL_MARGIN_PX};
  color: ${colorsPalette.gray};
  z-index: 1;
`;
